// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zdWtY","separator":"styles_separator__fVlrt"};